import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import axios from 'axios'
import VueRouter from 'vue-router'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(VueRouter)
Vue.use(BootstrapVue)

const home = () => import('./components/Home');
const ge = () => import('./components/GrandExchange');
const todo = () => import('./components/ToDo');
const gettingStarted = () => import('./components/GettingStarted');
const gettingStartedArticle = () => import('./components/GettingStartedArticle');
const notfound = () => import('./components/NotFound');

const routes = [
    { name: 'home', path: '/', component: home },
    { name: 'ge', path: '/ge', component: ge },
    { name: 'todo', path: '/todo', component: todo },
    {
        name: 'gettingstarted',
        path: '/getting-started',
        component: gettingStarted,
        children: [
            {
                path: ':article',
                name: 'gettingstartedarticle',
                component: gettingStartedArticle,
                props: route => ({ slug: route.params.article })
            }
        ]
    },
    { path: '/*', component: notfound },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
